const isShowMainPageFormWrapper = computed(() => true)
const authorizationModalTabs = ['sign_in', 'sign_in_as_b2b']

const additionalOptionsExpanded = ref(null)

const cityIdAdapter = cityId => +cityId

const getBookingPaymentCurrency = ({currency, citizenshipId}) => persistentStore.getCurrency(currency)

const isShowHotelEmailOnInfo = computed(() => true)

const forceIncludeInFee = false

export const customizationHelpers = {
    isShowMainPageFormWrapper,
    authorizationModalTabs,
    additionalOptionsExpanded,
    cityIdAdapter,
    getBookingPaymentCurrency,
    isShowHotelEmailOnInfo,
    forceIncludeInFee,
}

export function useCustomizationHelpers() {
    return customizationHelpers
}
